import React from "react"

import Row from "./Row"

export default function Confirmation({ clients, existingClients }) {
  return (
    <div className="columns is-centered">
      <div
        className={`column is-half ${
          existingClients.length === clients.length || existingClients.length === 0 ? "box" : ""
        }`}>
        {existingClients.length === clients.length ? (
          <div className="copy-paste-headline">Uh oh!</div>
        ) : (
          <div className="copy-paste-headline" style={{ marginBottom: "4px" }}>
            Import was completed!
          </div>
        )}
        <div>
          {existingClients.length ? (
            <div>
              {existingClients.length === clients.length ? (
                <div className="method-helper" style={{ marginBottom: "0" }}>
                  Looks like all of the clients you tried to add already exist in your directory.
                </div>
              ) : (
                <div className="method-helper">
                  Imported {clients.length - existingClients.length}{" "}
                  {clients.length - existingClients.length === 1 ? "client" : "clients"}.
                  <br />
                  <br />
                  <div style={{ fontWeight: "500", color: "#0B3954" }}>
                    These clients already exist in your directory
                  </div>
                  <div className="scrollable-area">
                    <table className="client-list table">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Email</th>
                          <th>First Name</th>
                          <th>Last Name</th>
                          <th>Phone Number</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {existingClients.map((row, index) => (
                          <Row
                            index={index + 1}
                            email={row.email}
                            firstName={row.firstName ?? row.first_name}
                            lastName={row.lastName ?? row.last_name}
                            phone={row.phone}
                            notes={row.notes}
                            key={index}
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="method-helper" style={{ marginBottom: "0", marginTop: "28px" }}>
              Imported {clients.length} {clients.length === 1 ? "client" : "clients"} into your directory.
            </div>
          )}
        </div>
        <a
          href="/portal/clients?refresh_clients=1"
          className="button btn-primary"
          style={{ marginTop: "32px", width: "100%" }}
          data-turbolinks="false">
          See Clients
        </a>
      </div>
    </div>
  )
}
